module.exports = __webpack_public_path__ + "img/xls-file 1.d7005716.svg";